import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import { getIPData, getFlagImageForCountry } from '../../common/helpers/IPDataHelper';
export default function extendCommentPost() {
  extend('flarum/forum/components/CommentPost', 'headerItems', function (items) {
    var _this$attrs$post$ipIn, _this$attrs$post, _app$session$user, _app$session$user$can;
    if (!app.forum.attribute('fof-geoip.showFlag')) return;
    const postUser = this.attrs.post.user();

    // A user-selected custom flag wins over the IP-based flag, but only while
    // the admin feature is enabled. If the admin later disables it, the stored
    // preference is not serialized (see the customFlagCountry field visibility
    // in extend.php), so we fall back to today's IP-based behaviour.
    if (postUser && app.forum.attribute('fof-geoip.allowCustomFlag')) {
      const customFlag = postUser.customFlagCountry();
      if (customFlag) {
        // Custom flag is self-disclosed and therefore visible to everyone.
        const image = getFlagImageForCountry(customFlag);
        if (image) {
          items.add('country', image, 100);
        }
        return;
      }
    }

    // IP-based flag: only shown to the post author's opted-in audience and
    // actors with permission to see the country.
    const ipInfo = (_this$attrs$post$ipIn = (_this$attrs$post = this.attrs.post).ipInfo) == null ? void 0 : _this$attrs$post$ipIn.call(_this$attrs$post);
    if ((ipInfo && postUser && postUser.showIPCountry() || (_app$session$user = app.session.user) != null && (_app$session$user$can = _app$session$user.canSeeCountry) != null && _app$session$user$can.call(_app$session$user)) && ipInfo) {
      const {
        image
      } = getIPData(ipInfo);
      if (image) {
        items.add('country', image, 100);
      }
    }
  });
}
flarum.reg.add('fof-geoip', 'forum/extenders/extendCommentPost', extendCommentPost);